import { capitalize } from "@msuite/utils/strings";
import { Button } from "../button";
import { Icon, icon } from "../icons";
import { Menu } from "../menu";
import { MapTypes } from "./constants";
import { useMapStore } from "./store";

export function MapMenu() {
	/** Hooks */
	const store = useMapStore();

	/** Render */
	return (
		<Menu
			items={() => [
				{
					label: "Type",
					icon: icon("Map"),
					items: MapTypes.map((mapType) => ({
						label: capitalize(mapType),
						icon: undefined,
						onClick: () => store.setMapType(mapType),
						isActive: store.mapType === mapType,
					})),
				},
				{
					label: "Disable clustering",
					icon: icon("Ungroup"),
					onClick: () => store.toggleDisableClustering(),
					isActive: store.disableClustering,
				},
			]}
		>
			<Button icon={<Icon name="EllipsisVertical" />} />
		</Menu>
	);
}
